/* Daline — shared interaction behaviour for custom sections */
(function () {
  function revealAll() {
    document.querySelectorAll('.dl-rev').forEach(function (el) {
      el.classList.add('dl-in');
    });
  }

  function initReveal() {
    var revs = document.querySelectorAll('.dl-rev');
    if (!revs.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('dl-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      revs.forEach(function (el, i) {
        el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
        io.observe(el);
      });
      window.addEventListener('load', function () {
        setTimeout(revealAll, 1500);
      });
    } else {
      revealAll();
    }
  }

  function initFilters() {
    document.querySelectorAll('[data-dl-filter]').forEach(function (group) {
      var targetSelector = group.getAttribute('data-dl-filter');
      group.querySelectorAll('button[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (b) {
            b.classList.remove('is-on');
          });
          btn.classList.add('is-on');
          var value = btn.getAttribute('data-value');
          document.querySelectorAll(targetSelector).forEach(function (item) {
            var itemValue = item.getAttribute('data-filter-value') || '';
            var itemValues = itemValue.split(',').map(function (v) { return v.trim(); });
            item.style.display = value === 'all' || itemValues.indexOf(value) !== -1 ? '' : 'none';
          });
        });
      });
    });
  }

  function dlPostcodeToState(pc) {
    if ((pc >= 1000 && pc <= 2599) || (pc >= 2619 && pc <= 2899) || (pc >= 2921 && pc <= 2999)) return 'NSW';
    if (pc === 200 || (pc >= 2600 && pc <= 2618) || (pc >= 2900 && pc <= 2920)) return 'ACT';
    if ((pc >= 3000 && pc <= 3999) || (pc >= 8000 && pc <= 8999)) return 'VIC';
    if ((pc >= 4000 && pc <= 4999) || (pc >= 9000 && pc <= 9999)) return 'QLD';
    if (pc >= 5000 && pc <= 5999) return 'SA';
    if (pc >= 6000 && pc <= 6999) return 'WA';
    if (pc >= 7000 && pc <= 7999) return 'TAS';
    if ((pc >= 800 && pc <= 899) || (pc >= 900 && pc <= 999)) return 'NT';
    return null;
  }

  function initStockistSearch() {
    var input = document.querySelector('[data-dl-stockist-search]');
    if (!input) return;
    var resultsWrap = document.querySelector('[data-dl-stockist-results]');
    var countEl = document.querySelector('[data-dl-stockist-count]');
    var hint = document.querySelector('[data-dl-stockist-hint]');
    var flatGrid = document.querySelector('[data-dl-stockist-flat]');
    var items = flatGrid ? Array.prototype.slice.call(flatGrid.querySelectorAll('.dl-stk')) : [];
    var chipsWrap = document.querySelector('[data-dl-stockist-chips]');
    var chips = chipsWrap ? Array.prototype.slice.call(chipsWrap.querySelectorAll('button')) : [];

    function showByState(state) {
      items.forEach(function (item) {
        var match = state === 'all' || item.getAttribute('data-state') === state;
        item.style.display = match ? '' : 'none';
      });
      var visibleCount = items.filter(function (i) { return i.style.display !== 'none'; }).length;
      hint.hidden = true;
      resultsWrap.hidden = false;
      countEl.textContent = state === 'all'
        ? visibleCount + ' stockist' + (visibleCount === 1 ? '' : 's') + ' found.'
        : visibleCount + ' stockist' + (visibleCount === 1 ? '' : 's') + ' found in ' + state + '.';
    }

    function render(query) {
      var q = query.trim().toLowerCase();
      if (!q) {
        resultsWrap.hidden = true;
        hint.hidden = false;
        return;
      }
      hint.hidden = true;
      chips.forEach(function (c) { c.classList.remove('is-on'); });

      var isPostcode = /^\d{4}$/.test(q);
      var targetState = isPostcode ? dlPostcodeToState(parseInt(q, 10)) : null;

      items.forEach(function (item) {
        var postcode = item.getAttribute('data-postcode') || '';
        var itemState = item.getAttribute('data-state') || '';
        var search = item.getAttribute('data-search') || '';
        var match = false;
        var dist = Infinity;
        if (isPostcode && targetState) {
          // Only ever show stockists in the same state as the searched postcode -
          // raw numeric distance alone is misleading across state boundaries.
          if (itemState === targetState) {
            match = true;
            dist = postcode ? Math.abs(parseInt(postcode, 10) - parseInt(q, 10)) : 500000;
          }
        } else if (isPostcode && postcode) {
          dist = Math.abs(parseInt(postcode, 10) - parseInt(q, 10));
          match = true;
        } else if (search.indexOf(q) !== -1) {
          match = true;
          dist = 0;
        }
        item.style.display = match ? '' : 'none';
        item.dataset.dist = isFinite(dist) ? dist : 999999;
      });
      items
        .slice()
        .sort(function (a, b) { return parseFloat(a.dataset.dist) - parseFloat(b.dataset.dist); })
        .forEach(function (item) { flatGrid.appendChild(item); });

      var visibleCount = items.filter(function (i) { return i.style.display !== 'none'; }).length;
      resultsWrap.hidden = false;
      if (visibleCount === 0 && isPostcode && targetState) {
        countEl.textContent = 'No stockists in ' + targetState + ' yet — try a different postcode, or pick a state above.';
      } else if (visibleCount === 0) {
        countEl.textContent = 'No stockists found for "' + query + '" yet — try a nearby suburb, or pick a state above.';
      } else if (isPostcode) {
        countEl.textContent = 'Showing stockists near ' + query + (targetState ? ' (' + targetState + ')' : '') + ', nearest first.';
      } else {
        countEl.textContent = visibleCount + ' stockist' + (visibleCount === 1 ? '' : 's') + ' found.';
      }
    }

    input.addEventListener('input', function () { render(input.value); });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');
        input.value = '';
        showByState(chip.getAttribute('data-value'));
      });
    });

    // Arriving from the homepage teaser search — prefill and run automatically.
    var presetQuery = new URLSearchParams(window.location.search).get('q');
    if (presetQuery) {
      input.value = presetQuery;
      render(presetQuery);
      input.scrollIntoView({ block: 'center' });
    }
  }

  function initStockistTeaser() {
    document.querySelectorAll('[data-dl-stockist-teaser]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-dl-stockist-teaser-input]');
      var resultsWrap = wrap.parentElement.querySelector('[data-dl-stockist-teaser-results]');
      var countEl = resultsWrap.querySelector('[data-dl-stockist-teaser-count]');
      var grid = resultsWrap.querySelector('[data-dl-stockist-teaser-grid]');
      var moreLink = resultsWrap.querySelector('[data-dl-stockist-teaser-more]');
      var sourceUrl = wrap.getAttribute('data-source-url');
      var baseMoreHref = moreLink.getAttribute('href');
      var itemsPromise = null;
      var debounceTimer = null;

      function loadItems() {
        if (itemsPromise) return itemsPromise;
        itemsPromise = fetch(sourceUrl)
          .then(function (res) {
            if (!res.ok) throw new Error('Stockist fetch failed: ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = Array.prototype.slice.call(doc.querySelectorAll('.dl-stk')).map(function (el) {
              // Strip the scroll-reveal class — these cards are injected long after
              // initReveal()'s one-time observer setup runs, so dl-rev would leave
              // them stuck at opacity:0 forever with no scroll event left to trigger it.
              el.classList.remove('dl-rev');
              return {
                state: el.getAttribute('data-state') || '',
                postcode: el.getAttribute('data-postcode') || '',
                search: el.getAttribute('data-search') || '',
                html: el.outerHTML
              };
            });
            if (!items.length) throw new Error('Stockist fetch returned no items');
            return items;
          })
          .catch(function (err) {
            if (window.console) console.error('[dl-stockist-teaser]', err);
            // Don't cache a failed/empty fetch — let the next search retry instead
            // of permanently showing "no stockists found" for the rest of the visit.
            itemsPromise = null;
            return [];
          });
        return itemsPromise;
      }
      // Warm the cache immediately so the first keystroke feels instant.
      loadItems();

      function render(query) {
        var q = query.trim().toLowerCase();
        if (!q) {
          resultsWrap.hidden = true;
          grid.innerHTML = '';
          return;
        }
        loadItems().then(function (items) {
          var wasHidden = resultsWrap.hidden;
          var isPostcode = /^\d{4}$/.test(q);
          var targetState = isPostcode ? dlPostcodeToState(parseInt(q, 10)) : null;
          var matches = items.filter(function (item) {
            if (isPostcode && targetState) return item.state === targetState;
            if (isPostcode) return true;
            return item.search.indexOf(q) !== -1;
          });
          if (isPostcode) {
            matches.sort(function (a, b) {
              var da = a.postcode ? Math.abs(parseInt(a.postcode, 10) - parseInt(q, 10)) : 999999;
              var db = b.postcode ? Math.abs(parseInt(b.postcode, 10) - parseInt(q, 10)) : 999999;
              return da - db;
            });
          }
          var shown = matches.slice(0, 5);
          grid.innerHTML = shown.map(function (m) { return m.html; }).join('');
          resultsWrap.hidden = false;
          if (wasHidden) resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          if (matches.length === 0 && isPostcode && targetState) {
            countEl.textContent = 'No stockists in ' + targetState + ' yet — try a nearby postcode.';
          } else if (matches.length === 0) {
            countEl.textContent = 'No stockists found for "' + query + '" yet.';
          } else if (isPostcode) {
            countEl.textContent = 'Nearest to ' + query + (targetState ? ' (' + targetState + ')' : '') + '.';
          } else {
            countEl.textContent = matches.length + ' stockist' + (matches.length === 1 ? '' : 's') + ' found.';
          }
          if (matches.length > shown.length) {
            moreLink.hidden = false;
            moreLink.href = baseMoreHref + (baseMoreHref.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(query);
          } else {
            moreLink.hidden = true;
          }
        });
      }

      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var value = input.value;
        debounceTimer = setTimeout(function () { render(value); }, 150);
      });
    });
  }

  function initDotSync() {
    document.querySelectorAll('[data-dl-dots]').forEach(function (dotsEl) {
      var trackSelector = dotsEl.getAttribute('data-dl-dots');
      var track = document.querySelector(trackSelector);
      if (!track) return;
      var dots = dotsEl.querySelectorAll('i');
      if (!dots.length) return;
      track.addEventListener(
        'scroll',
        function () {
          var index = Math.round(track.scrollLeft / (track.scrollWidth / dots.length));
          dots.forEach(function (d, n) {
            d.classList.toggle('is-on', n === Math.min(index, dots.length - 1));
          });
        },
        { passive: true }
      );
    });
  }

  function initTimelineJump() {
    document.querySelectorAll('[data-dl-timeline-nav]').forEach(function (nav) {
      nav.querySelectorAll('button[data-target]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          nav.querySelectorAll('button').forEach(function (b) {
            b.classList.remove('is-on');
          });
          btn.classList.add('is-on');
          var target = document.getElementById(btn.getAttribute('data-target'));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        });
      });
    });
  }

  function initArrowSliders() {
    document.querySelectorAll('[data-dl-arrow-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('.dl-track');
      var prev = wrap.querySelector('.dl-arrow--prev');
      var next = wrap.querySelector('.dl-arrow--next');
      var fill = wrap.querySelector('.dl-progress-fill');
      if (!track) return;
      function step(dir) {
        var card = track.querySelector(':scope > *');
        var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      function updateFill() {
        if (!fill) return;
        var max = track.scrollWidth - track.clientWidth;
        var pct = max > 0 ? (track.scrollLeft / max) * 100 : 100;
        fill.style.width = Math.max(12, Math.min(100, pct + 12)) + '%';
      }
      track.addEventListener('scroll', updateFill, { passive: true });
      updateFill();

      if (
        wrap.hasAttribute('data-dl-mobile-autoslide') &&
        window.matchMedia('(max-width:680px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        var dlAutoPaused = false;
        track.addEventListener('pointerdown', function () { dlAutoPaused = true; }, { passive: true });
        setInterval(function () {
          if (dlAutoPaused) return;
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 0) return;
          if (track.scrollLeft >= max - 4) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            step(1);
          }
        }, 3400);
      }
    });
  }

  function initCompactSubPicker() {
    document.querySelectorAll('[data-dl-compact-sub]').forEach(function (wrap) {
      var hidden = wrap.querySelector('[data-dl-selling-plan-input]');
      var toggle = wrap.querySelector('[data-dl-selling-plan-toggle]');
      var select = wrap.querySelector('[data-dl-selling-plan-select]');
      var label = toggle ? toggle.closest('.dl-pack-sub-toggle') : null;
      if (!toggle || !select || !hidden) return;
      function sync() {
        if (toggle.checked) {
          select.hidden = false;
          hidden.value = select.value;
        } else {
          select.hidden = true;
          hidden.value = '';
        }
        if (label) label.classList.toggle('is-checked', toggle.checked);
      }
      toggle.addEventListener('change', sync);
      select.addEventListener('change', sync);
      sync();
    });
  }

  function initSellingPlanPicker() {
    document.querySelectorAll('[data-dl-selling-plan-picker]').forEach(function (wrap) {
      var hidden = wrap.querySelector('[data-dl-selling-plan-input]');
      wrap.querySelectorAll('[data-dl-selling-plan-radio]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          hidden.value = radio.value;
        });
      });
    });
  }

  function initBackToTop() {
    var btn = document.querySelector('[data-dl-back-to-top]');
    if (!btn) return;
    window.addEventListener(
      'scroll',
      function () {
        btn.classList.toggle('is-visible', window.scrollY > 600);
      },
      { passive: true }
    );
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initTapToPlayVideo() {
    document.querySelectorAll('[data-dl-tap-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;
      wrap.addEventListener('click', function () {
        var playIcon = wrap.querySelector('.dl-play');
        if (video.paused) {
          video.play();
          if (playIcon) playIcon.style.display = 'none';
        } else {
          video.pause();
          if (playIcon) playIcon.style.display = 'flex';
        }
      });
    });
  }

  function initSplitSlideshows() {
    document.querySelectorAll('[data-dl-slideshow]').forEach(function (wrap) {
      var slides = wrap.querySelectorAll('img');
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 2200);
    });
  }

  function initAutoScrollers() {
    document.querySelectorAll('[data-dl-autoscroll]').forEach(function (track) {
      var interval = parseInt(track.getAttribute('data-dl-autoscroll'), 10) || 3200;
      setInterval(function () {
        if (track.scrollWidth <= track.clientWidth + 4) return;
        var card = track.children[0];
        var step = card ? card.getBoundingClientRect().width + 12 : 200;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
      }, interval);
    });
  }

  function initKlaviyoReviewsAutoScroll() {
    function start(track) {
      if (track.dataset.dlKlAutoInit) return;
      track.dataset.dlKlAutoInit = '1';
      setInterval(function () {
        if (track.scrollWidth <= track.clientWidth + 4) return;
        var card = track.children[0];
        var step = card ? card.getBoundingClientRect().width + 20 : 340;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
      }, 3800);
    }
    var existing = document.querySelector('.kl_reviews__list_container > div:first-child');
    if (existing) { start(existing); return; }
    var tries = 0;
    var observer = new MutationObserver(function () {
      var track = document.querySelector('.kl_reviews__list_container > div:first-child');
      if (track) { start(track); observer.disconnect(); }
      tries++;
      if (tries > 200) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initTextRotators() {
    document.querySelectorAll('[data-dl-text-rotator]').forEach(function (wrap) {
      var items = wrap.querySelectorAll('span');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 3000);
    });
  }

  function initPackPhotoPreview() {
    // Desktop mouse users get the swap via CSS :hover. On top of that, as the
    // pack slider is swiped/scrolled, whichever card sits centred in view
    // briefly reveals its second photo, then always returns to photo 1 -
    // photo 1 is the permanent resting state, photo 2 is just a peek.
    document.querySelectorAll('[data-dl-arrow-slider] .dl-track').forEach(function (track) {
      var cards = track.querySelectorAll('[data-dl-photo-preview]');
      if (!cards.length) return;
      var revertTimer = null;
      function updateActive() {
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width / 2;
        var closest = null;
        var closestDist = Infinity;
        cards.forEach(function (card) {
          var r = card.getBoundingClientRect();
          var dist = Math.abs(r.left + r.width / 2 - centerX);
          if (dist < closestDist) {
            closestDist = dist;
            closest = card;
          }
        });
        cards.forEach(function (card) { card.classList.remove('is-revealed'); });
        if (closest) closest.classList.add('is-revealed');
        if (revertTimer) clearTimeout(revertTimer);
        revertTimer = setTimeout(revertAll, 900);
      }
      function revertAll() {
        if (revertTimer) clearTimeout(revertTimer);
        cards.forEach(function (card) { card.classList.remove('is-revealed'); });
      }
      track.addEventListener('scroll', updateActive, { passive: true });
      track.addEventListener('scrollend', revertAll);
      track.addEventListener('touchend', function () { setTimeout(revertAll, 900); }, { passive: true });
    });
  }

  function initCartLineSubscribe() {
    document.querySelectorAll('[data-dl-cart-sub]').forEach(function (wrap) {
      var lineKey = wrap.getAttribute('data-line-key');
      var toggle = wrap.querySelector('[data-dl-cart-sub-toggle]');
      var select = wrap.querySelector('[data-dl-cart-sub-select]');
      var removeBtn = wrap.querySelector('[data-dl-cart-sub-remove]');
      function changeLine(sellingPlanId) {
        wrap.style.opacity = '.5';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, selling_plan: sellingPlanId || null }),
        }).then(function () {
          window.location.reload();
        });
      }
      if (toggle && select) {
        toggle.addEventListener('change', function () {
          select.hidden = !toggle.checked;
          changeLine(toggle.checked ? select.value : null);
        });
        select.addEventListener('change', function () {
          if (toggle.checked) changeLine(select.value);
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', function () { changeLine(null); });
      }
    });
  }

  function initPenShowcase() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('[data-dl-pen-stage]').forEach(function (stage) {
      var tilt = stage.querySelector('[data-dl-pen-tilt]');
      if (!tilt) return;
      stage.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        tilt.style.transform = 'rotateY(' + (x * 16) + 'deg) rotateX(' + (y * -16) + 'deg)';
      });
      stage.addEventListener('mouseleave', function () {
        tilt.style.transform = 'rotateY(0deg) rotateX(0deg)';
      });
    });
  }

  function initPlaceholderCycler() {
    var examples = ['Try 2000…', 'Try 3121…', 'Try Bondi Junction…', 'Try your postcode…'];
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-dl-cycle-placeholder]').forEach(function (input) {
      if (reduceMotion) return;
      var exampleIndex = 0;
      var charIndex = 0;
      var deleting = false;
      function tick() {
        if (document.activeElement === input || input.value) {
          setTimeout(tick, 500);
          return;
        }
        var current = examples[exampleIndex];
        if (!deleting) {
          charIndex++;
          input.setAttribute('placeholder', current.slice(0, charIndex));
          if (charIndex === current.length) {
            deleting = true;
            setTimeout(tick, 1500);
            return;
          }
          setTimeout(tick, 70);
        } else {
          charIndex--;
          input.setAttribute('placeholder', current.slice(0, charIndex));
          if (charIndex === 0) {
            deleting = false;
            exampleIndex = (exampleIndex + 1) % examples.length;
            setTimeout(tick, 350);
            return;
          }
          setTimeout(tick, 35);
        }
      }
      input.addEventListener('blur', function () {
        if (!input.value) setTimeout(tick, 600);
      });
      tick();
    });
  }

  function initInstaMute() {
    document.querySelectorAll('[data-dl-insta-mute]').forEach(function (btn) {
      var card = btn.closest('.dl-insta-card');
      var video = card ? card.querySelector('video') : null;
      if (!video) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        btn.classList.toggle('is-unmuted', !video.muted);
      });
    });
  }

  function initForceAutoplay() {
    // Some mobile browsers (Low Power Mode, Data Saver, etc.) silently skip the
    // autoplay attribute and leave the video paused on its poster frame. Force
    // an explicit play() call, and retry on the first user gesture as a fallback
    // for browsers that require interaction before allowing playback.
    // Sections like the hero render a desktop AND a mobile <video> and hide one
    // via CSS - a hidden video still plays (and can still be audible) unless we
    // explicitly pause it, so only the one actually on screen should ever run.
    var videos = document.querySelectorAll('video[autoplay]');
    if (!videos.length) return;
    function sync() {
      videos.forEach(function (v) {
        var visible = v.getClientRects().length > 0 && getComputedStyle(v).display !== 'none';
        if (!visible) {
          if (!v.paused) v.pause();
          return;
        }
        if (v.paused) v.play().catch(function () {});
      });
    }
    sync();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sync();
    });
    ['touchstart', 'click', 'scroll'].forEach(function (evt) {
      document.addEventListener(evt, sync, { once: true, passive: true });
    });
    window.addEventListener('resize', sync, { passive: true });
  }

  function initHeroSound() {
    document.querySelectorAll('[data-dl-sound-toggle]').forEach(function (btn) {
      var hero = btn.closest('[data-dl-sound-scope]') || btn.closest('.dl-hero');
      if (!hero) return;
      var audio = hero.querySelector('[data-dl-hero-audio]');
      function visibleVideo() {
        var vids = hero.querySelectorAll('video');
        for (var i = 0; i < vids.length; i++) {
          if (getComputedStyle(vids[i]).display !== 'none') return vids[i];
        }
        return vids[0] || null;
      }
      btn.addEventListener('click', function () {
        var video = visibleVideo();
        var unmuting = video ? video.muted : (audio && audio.paused);
        if (video) video.muted = !unmuting;
        // Keep any hidden sibling video (desktop/mobile swap) muted regardless,
        // so switching viewport size never plays two audio tracks at once.
        hero.querySelectorAll('video').forEach(function (v) {
          if (v !== video) v.muted = true;
        });
        if (audio) {
          audio.muted = !unmuting;
          if (unmuting) audio.play().catch(function () {}); else audio.pause();
        }
        btn.setAttribute('aria-pressed', String(unmuting));
        btn.classList.toggle('is-unmuted', unmuting);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFilters();
    initStockistSearch();
    initStockistTeaser();
    initPlaceholderCycler();
    initPenShowcase();
    initDotSync();
    initTimelineJump();
    initArrowSliders();
    initCompactSubPicker();
    initSellingPlanPicker();
    initBackToTop();
    initTapToPlayVideo();
    initAutoScrollers();
    initKlaviyoReviewsAutoScroll();
    initPackPhotoPreview();
    initCartLineSubscribe();
    initInstaMute();
    initForceAutoplay();
    initHeroSound();
    initTextRotators();
    initSplitSlideshows();
  });
})();
